import { gql } from '@apollo/client'

export const SUGGESTION_BOX_QUERY = gql`
    query searchSuggestions(
        $query_string:String!, 
        $business_units:[String], 
        $departments:[String], 
        $file_extensions:[String],
        $types:[String],
        $dates:[String],
        $limit:Int){
            searchSuggestions(
                query_string: $query_string, 
                business_units: $business_units, 
                departments: $departments, 
                file_extensions: $file_extensions,
                types: $types,
                dates: $dates,
                limit:$limit
            )
        }
`;